import "./NavBar.css";
import { getDeployment, trackEvent } from "../../../Actions/Utils";
import { navTitle } from "../../../NewConstants/NavConstants";
import { deploymentNeGD } from "../../../NewConstants/DeploymentConstants";

const NavBar = ({ setStartTour, selectedLanguage, textSize, toggleMenu = () => {}, toggleHelp = () => {}, showTooltipChecklist, setShowTooltipChecklist }) => {
  const isIframe = getDeployment() === deploymentNeGD;
  const handleFeedbackClick = () => {
    toggleHelp();
    trackEvent("Feedback/Support", "Click", "Open Feedback/Support Icon (NavBar)");
  };
  const handletoggleMene = () => {
    toggleMenu();
    trackEvent("Hamburger", "Click", "Open Side Menu");
  };
  const handleStartTour = () => {
    setShowTooltipChecklist(true);
  };
  return (
    <div className="flex justify-between items-center pt-2 px-4 z-0 navBarDiv" style={{backgroundImage:  isIframe ? "url(/Assets/Images/NavBackground.svg)" : "none", height: isIframe ? "3.75rem" : "auto"}}>
      <div onClick={handletoggleMene}>
        <img src={isIframe ? "/Assets/Images/NavBar_White.svg" : "/Assets/Images/NavBar.svg"} alt="Navbar" />
      </div>
      <div className={`font-semibold flex items-center justify-center gap-2.5 py-4 nameBarDiv`} style={{fontSize: `${textSize}rem`}}>
        {isIframe ? "" : navTitle[selectedLanguage]}
      </div>
      <div onClick={handleStartTour} id="tour-help-circle" style={{marginRight: isIframe ? "3.75rem" : "0"}}>
        <img src={"/Assets/Images/helpCircle.svg"} alt="Help" />
      </div>
    </div>
  );
};

export default NavBar;
